export const LEGACY_MEMO_PATTERNS = [
  /^(Cash|Metal) settlement for refining lot \S+(?: - \S+)?$/u,
  /^Spot lock for(?: settlement of)? refining lot \S+(?: - \S+| \(Ref: [^)]*\))?$/u,
  /^Cash advance for refining lot \S+(?: - \S+| \(Ref: [^)]*\))?$/u,
  /^Metal receipt for settlement \S+ - \S+$/u,
  /^Fulfilling [\d.]+ \S+ from lock \S+ via source transaction \S+$/u,
  /^Spot lock SELL for [\d.]+ ozt .+$/u,
  /^Cash out of .+ in .+$/u,
]

export function isLegacyMemo(memo) {
  if (!memo || typeof memo !== 'string') return false
  const trimmed = memo.trim()
  if (!trimmed) return false
  return LEGACY_MEMO_PATTERNS.some((pattern) => pattern.test(trimmed))
}

export function sanitizeMemo(val, stripRef = false) {
  if (!val || typeof val !== 'string') return val
  let memo = val
  // Remove UUID patterns (8-4-4-4-12 hex format)
  memo = memo.replace(/\s+[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '')
  // Remove trailing 10-digit numbers (spot lock sequence numbers)
  memo = memo.replace(/\s+\d{10}$/i, '')
  // Optionally remove non-empty reference numbers like "(Ref: 1234)"
  if (stripRef) {
    memo = memo.replace(/\s*\(Ref:\s*[^)]*\)/gi, '')
  }
  // Always remove empty reference numbers like "(Ref: )" or "(Ref:)"
  memo = memo.replace(/\s*\(Ref:\s*\)/gi, '')
  // Clean up any trailing dashes, spaces, or punctuation
  memo = memo.replace(/[\s,:;-]+$/, '').trim()
  // If sanitization removed everything, return original value
  return memo || val
}

export function formatTransactionMemoForDisplay(memo) {
  if (!memo || typeof memo !== 'string') return ''
  const trimmed = memo.trim()
  if (!trimmed || isLegacyMemo(trimmed)) return ''
  const sanitized = sanitizeMemo(memo, true)
  if (!sanitized || isLegacyMemo(String(sanitized).trim())) return ''
  return sanitized
}
